import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { isPlural, trDict } from '../../../helpers/Utils'
import { IElementProps } from '../../../types/interfaces'

const GenericDropDown = (props: IElementProps) => {
  const { t } = useTranslation('common')
  const externalDataTimestamp = useRef<number>(0)
  const [options, setOptions] = useState<number[]>([])

  useEffect(() => {
    const newTimestamp = props.externalData?.timeStamp ?? 0
    if (newTimestamp > externalDataTimestamp.current) {
      externalDataTimestamp.current = newTimestamp
    }
  }, [props.externalData])

  useEffect(() => {
    const opts: number[] = []
    if (!!props.minimumValue && !!props.maximumValue && !!props.step) {
      if (props.minimumValue < props.maximumValue) {
        if (props.step < 0) {
          setOptions([])
          return
        }
        for (let i = props.minimumValue; i <= props.maximumValue; i += props.step) {
          opts.push(i)
        }
        setOptions(opts)
      }

      if (props.minimumValue > props.maximumValue) {
        if (props.step > 0) {
          setOptions([])
          return
        }
        for (let i = props.minimumValue; i >= props.maximumValue; i += props.step) {
          opts.push(i)
        }
        setOptions(opts)
      }
    }
  }, [props.maximumValue, props.minimumValue, props.step])

  const { lang: language } = props

  const getUnits = (val: number) => {
    const unit = isPlural(val) ? trDict(language, props.unitsTrPlural) : trDict(language, props.unitsTrSingular)
    return unit || props.label
  }

  return (
    <>
      {props.visible && (
        <div className="formGroup">
          <div className="labelTooltip">
            {props.translatedTooltip && (
              <>
                <div className="tooltipArea">
                  <i className="icon-info"></i>
                  <div className="tooltip">{props.translatedTooltip}</div>
                </div>
              </>
            )}
            <label>{props.label}</label>
          </div>
          <div className="selectArea selectfuelCard required-highlight">
            <select
              onChange={(e) => props.handleChange(props.name, e)}
              value={props.value || ''}
              disabled={props.formReadOnly || props.disabledInput}
            >
              <option disabled={true} value="">
                {options.length > 0 ? t('PLEASE_SELECT_A_VALUE') : t('NO_VALUE_TO_SHOW')}
              </option>
              {options.map((el) => (
                <option value={el}>{el + ' ' + getUnits(el)}</option>
              ))}
            </select>
            <i className="icon-bottom" />
          </div>
        </div>
      )}
    </>
  )
}
export default GenericDropDown
